<template>
  <div id="RequestLetterTaghirAghsat" class="bnp-ta" dir="rtl">
    <panel
      Title="درخواست تغییر اقساط"
      Des="از طریق این فرم می‌توانید درخواست کاهش مدت پرداخت اقساط خود را برای مدیر سامانه ارسال کنید."
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="row px-3">
      <div class="col-12 col-md-12 mx-md-2 p-md-3">
        <net-pa-tab :Tabs="RequestTabs" :Active="activeTab" @change="onTabChange"></net-pa-tab>
        <div class="tab-content">
          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'nav-ta-form' }"
            id="nav-ta-form"
            role="tabpanel"
            aria-labelledby="nav-ta-form-tab"
          >
            <net-pa-card :Compact="true">
              <template slot="content">
                <!-- درخواست در حال بررسی -->
                <div v-if="HasPendingRequest" class="bnp-ta-pending" role="status">
                  <i class="fas fa-hourglass-half bnp-ta-pending__icon" aria-hidden="true"></i>
                  <div class="bnp-ta-pending__body">
                    <div class="bnp-ta-pending__title">
                      درخواست شما در حال بررسی است
                      <span class="bnp-ta-badge bnp-ta-badge--warning">در حال بررسی</span>
                    </div>
                    <p class="bnp-ta-pending__text">
                      عضو محترم، درخواست تغییر اقساط شما در تاریخ <b dir="ltr">{{ zamanInsert }}</b> ارسال شده است. تا زمان تعیین وضعیت توسط مدیر سامانه، امکان ارسال درخواست جدید وجود ندارد.
                    </p>
                  </div>
                </div>

                <!-- فرم نامه -->
                <div v-else class="bnp-ta-form">
                  <header class="bnp-ta-letter-head">
                    <span class="bnp-ta-eyebrow">{{ $store.state.NameSandogh }}</span>
                    <h5 class="bnp-ta-letter-title">فرم درخواست تغییر اقساط</h5>
                  </header>

                  <div class="bnp-ta-salutation">
                    <p class="bnp-ta-salutation__to">مدیرعامل محترم شرکت تعاونی اعتبار</p>
                    <p>با سلام</p>
                    <p>احتراماً، خواهشمند است دستور فرمایید نسبت به کاهش مدت پرداخت اقساط اینجانب اقدامات لازم مبذول گردد.</p>
                  </div>

                  <dl class="bnp-ta-tiles">
                    <div class="bnp-ta-tile">
                      <dt>درخواست‌کننده</dt>
                      <dd>{{ NamFam || '—' }}</dd>
                    </div>
                    <div class="bnp-ta-tile">
                      <dt>کد ملی</dt>
                      <dd dir="ltr" class="bnp-ta-ltr">{{ CodeMeli || '—' }}</dd>
                    </div>
                  </dl>

                  <div class="bnp-ta-request">
                    <div class="bnp-ta-section-title">
                      <i class="fas fa-calendar-minus" aria-hidden="true"></i>
                      مدت جدید پرداخت اقساط
                    </div>
                    <p class="bnp-ta-request__desc">
                      اینجانب <b>{{ NamFam }}</b> با کد ملی <b dir="ltr">{{ CodeMeli }}</b> درخواست کاهش مدت پرداخت اقساط به مدت
                      <b>{{ Modat || '...' }}</b> ماه را دارم.
                    </p>
                    <div class="bnp-ta-field">
                      <label for="taModat" class="bnp-ta-label">مدت پرداخت اقساط</label>
                      <div class="bnp-ta-unit-wrap">
                        <input
                          id="taModat"
                          v-model="Modat"
                          type="text"
                          dir="ltr"
                          inputmode="numeric"
                          autocomplete="off"
                          placeholder="0"
                          class="form-control bnp-ta-control"
                          @keypress="$ValidNumber($event, 3)"
                          @keyup.enter="question()"
                        />
                        <span class="bnp-ta-unit">ماه</span>
                      </div>
                      <small class="bnp-ta-help">تعداد ماه‌های مدنظر برای پرداخت باقی‌مانده اقساط را وارد کنید.</small>
                    </div>
                  </div>

                  <div class="bnp-ta-footer">
                    <button type="button" class="bnp-ta-btn bnp-ta-btn--primary" :disabled="IsSending" @click="question()">
                      <i class="fas fa-paper-plane" aria-hidden="true"></i>
                      {{ IsSending ? 'در حال ارسال...' : 'ثبت درخواست' }}
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
          </div>

          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'nav-ta-history' }"
            id="nav-ta-history"
            role="tabpanel"
            aria-labelledby="nav-ta-history-tab"
          >
            <net-pa-card :Compact="true">
              <template slot="content">
                <div v-if="ListRequest.length == 0" class="bnp-ta-empty">
                  <i class="fas fa-inbox" aria-hidden="true"></i>
                  تاکنون درخواستی ثبت نکرده‌اید.
                </div>

                <ul v-else class="bnp-ta-history">
                  <li v-for="(item, index) in HistoryList" :key="index" class="bnp-ta-history__item">
                    <div class="bnp-ta-history__head">
                      <span class="bnp-ta-history__date">
                        <i class="far fa-calendar-alt" aria-hidden="true"></i>
                        <span dir="ltr">{{ item.zamanInsert }}</span>
                      </span>
                      <span class="bnp-ta-badge" :class="'bnp-ta-badge--' + StatusOf(item).tone">
                        <i :class="StatusOf(item).icon" aria-hidden="true"></i>
                        {{ StatusOf(item).text }}
                      </span>
                    </div>
                    <dl class="bnp-ta-history__grid">
                      <div>
                        <dt>مدت درخواستی اقساط</dt>
                        <dd>{{ item.modat == null || item.modat === '' ? '—' : item.modat + ' ماه' }}</dd>
                      </div>
                    </dl>
                  </li>
                </ul>
              </template>
            </net-pa-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import Panel from '../Tools/NetPa/Panel.vue'
import NetPaTab from '../Tools/NetPa/NetPaTab.vue'
export default {
  components: { NetPaCard, Panel, NetPaTab },
  data() {
    return {
      NamFam: '',
      CodeMeli: '',
      Modat: null,
      DataAxios: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'Letter/PostTaghirAghsat',
        Token: this.$session.get('TokenNetPa'),
      },
      IsEnsraf: false,
      IsSending: false,
      zamanInsert: '',
      ListRequest: [],
      activeTab: 'nav-ta-form',
    }
  },
  computed: {
    RequestTabs() {
      return [
        { id: 'nav-ta-form', title: 'ثبت درخواست' },
        { id: 'nav-ta-history', title: this.ListRequest.length ? 'سوابق درخواست (' + this.ListRequest.length + ')' : 'سوابق درخواست' },
      ]
    },
    HasPendingRequest() {
      return this.ListRequest.length > 0 && this.ListRequest[this.ListRequest.length - 1].vaziatGrp44 == null
    },
    HistoryList() {
      return this.ListRequest.slice().reverse()
    },
  },
  mounted() {
    this.NamFam = this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily
    this.CodeMeli = this.$session.get('UserInfoNetPa').codeMeli.trim()
    this.GetData()
  },
  methods: {
    onTabChange(id) {
      this.activeTab = id
    },
    switchTab(id) {
      this.activeTab = id
      this.$nextTick(() => {
        const link = document.getElementById(id + '-tab')
        if (link && window.$) {
          window.$(link).tab('show')
        } else if (link) {
          link.click()
        }
      })
    },
    StatusOf(item) {
      if (item.vaziatGrp44 == 7190) return { tone: 'success', icon: 'fas fa-check-circle', text: 'تأیید شد' }
      if (item.vaziatGrp44 == 7191) return { tone: 'danger', icon: 'fas fa-times-circle', text: 'رد شد' }
      return { tone: 'warning', icon: 'fas fa-hourglass-half', text: 'در حال بررسی' }
    },
    question() {
      if (this.Modat == null || String(this.Modat).trim() == '' || Number(this.Modat) <= 0) {
        this.$mySweetDefault('خطا', 'لطفاً مدت پرداخت اقساط را به ماه وارد کنید', 'error', 2500)
        return
      }
      this.$SweetQustion('اطمینان از ثبت درخواست', 'آیا از ثبت درخواست تغییر اقساط اطمینان دارید؟', 'question', 'تایید ', 'انصراف', this.CodeMeli, this.SendData, this.isNotConfirmed)
    },
    SendData() {
      this.DataAxios.ArryfildValue.NamFam = this.NamFam
      this.DataAxios.ArryfildValue.CodeMeli = this.CodeMeli
      this.DataAxios.ArryfildValue.Modat = this.Modat
      this.IsSending = true
      this.$PostData(this.DataAxios)
        .then((result) => {
          if (result) {
            this.$mySweetDefaultTost('عملیات موفق', 'درخواست تغییر اقساط شما با موفقیت ثبت گردید', 'success', 2000)
            this.switchTab('nav-ta-history')
          }
        })
        .finally(() => {
          this.IsSending = false
          this.GetData()
        })
    },
    isNotConfirmed() {},
    GetData() {
      var formdata = new FormData()
      formdata.append('codemeli', this.CodeMeli)
      var DataAxios_GetData = {
        ArryfildValue: formdata,
        Method: 'Post',
        Action: 'Letter/GetTaghirAghsat',
        Token: this.$session.get('TokenNetPa'),
      }
      this.$PostFormData(DataAxios_GetData).then((data) => {
        if (data.length > 0) {
          this.IsEnsraf = true
          this.zamanInsert = data[data.length - 1].zamanInsert
          this.ListRequest = data
        } else this.IsEnsraf = false
      })
    },
  },
}
</script>
<style scoped>
.bnp-ta {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-brand-blue: #287db4;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-surface-subtle: #f9fbfc;
  --bnp-info-soft: #edf5fb;
  --bnp-border-default: #dbe5eb;
  --bnp-border-subtle: #e8eef2;
  --bnp-border-hover: #bdcbd4;
  --bnp-warning: #c48726;
  --bnp-warning-soft: #fff7e8;
  --bnp-danger: #b44f46;
  --bnp-danger-surface: #fcefed;
  --bnp-radius-md: 14px;
  --bnp-shadow-md: 0 12px 24px rgba(41, 52, 95, 0.18);
  --bnp-focus-color: #05b8c8;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-motion-fast: 180ms;

  color: var(--bnp-text-primary);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  text-align: right;
}

.bnp-ta-ltr {
  unicode-bidi: plaintext;
  text-align: right;
}

/* ---------- Letter head ---------- */
.bnp-ta-letter-head {
  padding-bottom: 14px;
  margin-bottom: 16px;
  text-align: center;
  border-bottom: 1px solid var(--bnp-border-subtle);
}

.bnp-ta-eyebrow {
  display: block;
  margin-bottom: 4px;
  color: var(--bnp-brand-blue);
  font-size: 12px;
  font-weight: 700;
}

.bnp-ta-letter-title {
  margin: 0;
  color: var(--bnp-brand-navy);
  font-size: 18px;
  font-weight: 800;
  line-height: 1.6;
}

.bnp-ta-salutation {
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.9;
}

.bnp-ta-salutation p {
  margin: 0;
}

.bnp-ta-salutation__to {
  color: var(--bnp-brand-navy);
  font-weight: 700;
}

/* ---------- Tiles ---------- */
.bnp-ta-tiles {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 0 0 20px;
}

.bnp-ta-tile {
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid var(--bnp-border-subtle);
  border-radius: 12px;
  background: var(--bnp-surface-subtle);
}

.bnp-ta-tile dt {
  margin: 0 0 2px;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.8;
}

.bnp-ta-tile dd {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  word-break: break-word;
}

/* ---------- Request block ---------- */
.bnp-ta-request {
  padding: 14px 16px;
  border: 1px solid rgba(5, 184, 200, 0.4);
  border-radius: var(--bnp-radius-md);
  background: linear-gradient(100deg, rgba(5, 184, 200, 0.05), rgba(141, 88, 164, 0.03) 60%, #fff);
}

.bnp-ta-section-title {
  margin-bottom: 6px;
  color: var(--bnp-brand-navy);
  font-size: 14px;
  font-weight: 800;
}

.bnp-ta-section-title i {
  margin-left: 6px;
  color: var(--bnp-brand-blue);
}

.bnp-ta-request__desc {
  margin: 0 0 12px;
  color: var(--bnp-text-secondary);
  font-size: 13px;
  line-height: 1.9;
}

.bnp-ta-request__desc b {
  color: var(--bnp-text-primary);
  font-weight: 700;
}

/* ---------- Field ---------- */
.bnp-ta-field {
  display: flex;
  flex-direction: column;
  max-width: 320px;
}

.bnp-ta-label {
  display: block;
  margin-bottom: 6px;
  color: var(--bnp-text-primary);
  font-size: 13px;
  font-weight: 700;
}

.bnp-ta-help {
  display: block;
  margin-top: 6px;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  line-height: 1.8;
}

.bnp-ta-unit-wrap {
  position: relative;
}

.bnp-ta-control {
  width: 100%;
  height: 48px;
  padding: 0 48px;
  color: var(--bnp-text-primary);
  font-family: inherit;
  font-size: 15px !important;
  font-weight: 700;
  text-align: center;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  background-color: var(--bnp-surface-subtle);
  transition:
    border-color var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease;
}

.bnp-ta-control:hover {
  border-color: var(--bnp-border-hover);
}

.bnp-ta-control:focus {
  border-color: var(--bnp-focus-color);
  background-color: #fff;
  box-shadow: var(--bnp-focus-ring);
  outline: none;
}

.bnp-ta-control::placeholder {
  color: #a3adb8;
  font-weight: 400;
}

.bnp-ta-unit {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 700;
  pointer-events: none;
}

/* ---------- Footer / button ---------- */
.bnp-ta-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid var(--bnp-border-subtle);
}

.bnp-ta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 200px;
  min-height: 52px;
  padding: 10px 22px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  border: 0;
  border-radius: var(--bnp-radius-md);
  outline: none;
  cursor: pointer;
  transition:
    transform var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease;
}

.bnp-ta-btn--primary {
  color: #fff;
  background: linear-gradient(110deg, var(--bnp-brand-navy), var(--bnp-brand-indigo) 58%, var(--bnp-brand-purple));
  box-shadow: var(--bnp-shadow-md);
}

.bnp-ta-btn--primary:hover:not(:disabled) {
  color: #fff;
  transform: translateY(-2px);
}

.bnp-ta-btn:focus-visible {
  box-shadow: var(--bnp-focus-ring);
}

.bnp-ta-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

/* ---------- Pending notice ---------- */
.bnp-ta-pending {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 18px;
  border: 1px solid rgba(196, 135, 38, 0.3);
  border-radius: var(--bnp-radius-md);
  background: var(--bnp-warning-soft);
}

.bnp-ta-pending__icon {
  display: inline-grid;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  place-items: center;
  color: var(--bnp-warning);
  font-size: 16px;
  border-radius: 12px;
  background: #fff;
  box-shadow: inset 0 0 0 1px rgba(196, 135, 38, 0.2);
}

.bnp-ta-pending__body {
  min-width: 0;
}

.bnp-ta-pending__title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  color: #6f4a0e;
  font-size: 14px;
  font-weight: 800;
}

.bnp-ta-pending__text {
  margin: 0;
  color: var(--bnp-text-primary);
  font-size: 13px;
  line-height: 1.9;
}

/* ---------- Badge ---------- */
.bnp-ta-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.6;
  border-radius: 999px;
}

.bnp-ta-badge--success {
  color: #047a6c;
  background: rgba(5, 168, 149, 0.12);
}

.bnp-ta-badge--warning {
  color: #8a5d12;
  background: #fdebc8;
}

.bnp-ta-badge--danger {
  color: var(--bnp-danger);
  background: var(--bnp-danger-surface);
}

/* ---------- History ---------- */
.bnp-ta-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 12px;
  color: var(--bnp-text-secondary);
  font-size: 13px;
  border: 1px dashed var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  background: var(--bnp-surface-subtle);
}

.bnp-ta-history {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 420px;
  margin: 0;
  padding: 0 0 0 4px;
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
}

.bnp-ta-history__item {
  padding: 12px 14px;
  border: 1px solid var(--bnp-border-subtle);
  border-radius: 12px;
  background: var(--bnp-surface-subtle);
}

.bnp-ta-history__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--bnp-border-subtle);
}

.bnp-ta-history__date {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--bnp-brand-navy);
  font-size: 13px;
  font-weight: 700;
}

.bnp-ta-history__date i {
  color: var(--bnp-brand-blue);
}

.bnp-ta-history__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px 12px;
  margin: 0;
}

.bnp-ta-history__grid dt {
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.8;
}

.bnp-ta-history__grid dd {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
}

/* ---------- Responsive ---------- */
@media (max-width: 575px) {
  .bnp-ta-tiles,
  .bnp-ta-history__grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .bnp-ta-field {
    max-width: none;
  }

  .bnp-ta-btn {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .bnp-ta-control,
  .bnp-ta-btn {
    transition: none;
  }

  .bnp-ta-btn--primary:hover:not(:disabled) {
    transform: none;
  }
}
</style>
